

import classes from './Header.module.css';

const Header = (props)=>{
      
    
    return (
        <header className={classes[props.type]}>
            {props.children}
        </header>
    )
}

export default Header;